<div class="view-all-values-dialog themed-dialog">
  <div class="view-all-values-dialog__header">
    <button
      mat-flat-button
      class="close only-icon"
      (click)="dialogRef.close()"
      [attr.aria-label]="'general.close' | translate">
      <span class="odilo-icon" aria-hidden="true">close</span>
    </button>

    <h3>{{ data.filter.label }}</h3>

    <mat-form-field>
      <input matInput name="filter" [placeholder]="typeToFilterLabel" (input)="doFilter($event.target.value)" />
    </mat-form-field>
  </div>

  <div class="content__list">
    <div *ngIf="!fetching" class="content__list" [class.lists-grid]="!themaList">
      <ng-container *ngIf="lists; then userLists; else filterList"></ng-container>
      <ng-template #userLists>
        <div
          class="content__list__item--list cover-img__list"
          *ngFor="let item of filteredValues"
          (click)="dialogRef.close(item)">
          {{item}}
          <div class="list__cover">
            <opac-record-cover
              [coverUrl]="item.covers[0]"
              [isList]="!!item.covers">
            </opac-record-cover>

            <div class="img__type">
              <span class="odilo-icon">list_notebook</span>
              <p>{{ 'general.viewMode.list' | translate }}</p>
            </div>
          </div>

          <div class="list__info">
            <div class="list-title">
              <p class="list__info__title">{{ item.name }}</p>
            </div>

            <p class="list__info__count" [ngPlural]="item.items.length">
              <ng-template ngPluralCase="=1">{{ item.items.length }} {{ 'general.item' | translate }}</ng-template>
              <ng-template ngPluralCase="other">{{ item.items.length }} {{ 'general.items' | translate }}</ng-template>
            </p>

            <p class="list__info__description fade-description">{{ item.description }}</p>
          </div>
        </div>
      </ng-template>

      <ng-template #filterList>
        <ng-container *ngIf="themaList; then twoLevelList; else oneLevelList"></ng-container>
      </ng-template>

      <ng-template #oneLevelList>
        <div
          class="content__list__item--filter"
          *ngFor="let item of filteredValues"
          (click)="dialogRef.close(item)"
          tabindex="0">
          <p>{{ adaptAndTranslate(item) }}</p>
          <span class="filter__count" *ngIf="item.value > 0">{{ item.value }}</span>
        </div>
      </ng-template>

      <ng-template #twoLevelList>
        <div class="thema-component__list">
          <mat-accordion displayMode="flat" multi="true">
            <mat-expansion-panel [expanded]="true" *ngFor="let item of filteredValues" class="list__item">
              <mat-expansion-panel-header
                class="list__item__title"
                tabindex="0"
                collapsedHeight="48px"
                expandedHeight="48px">
                <p class="title__link">{{ adaptAndTranslate(item) }}</p>
              </mat-expansion-panel-header>

              <div class="list__item__content" *ngIf="item.subFilter">
                <div
                  class="content__name"
                  *ngFor="let thema of item.subFilter"
                  (keydown.enter)="dialogRef.close({ name: thema.criteria })"
                  (keydown.space)="dialogRef.close({ name: thema.criteria })"
                  (click)="dialogRef.close({ name: thema.criteria })"
                  tabindex="0">
                  <p class="content__name__title">{{ adaptAndTranslate(thema) }}</p>
                  <span class="content__name__count">{{ thema.value }}</span>
                </div>
              </div>
            </mat-expansion-panel>
          </mat-accordion>
        </div>
      </ng-template>
    </div>
    <div class="loading-animation" *ngIf="fetching">
      <div class="animation-row">
        <div class="double-bounce">
          <div class="child double-bounce1"></div>
          <div class="child double-bounce2"></div>
        </div>
      </div>
    </div>
    <mat-paginator
      *ngIf="lists"
      [length]="paginatorLength"
      [pageSize]="pageSize"
      [pageSizeOptions]="pageSizeOptions"
      [showFirstLastButtons]="true"
      (page)="pageChangeHandler($event)"></mat-paginator>
  </div>
</div>
